import "./openSession.scss";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { RiSendPlaneFill } from "react-icons/ri";
import { getOrchardUrlFromEnv } from "utils/environment.util";
import { Button, Form } from "react-bootstrap";
import { icons } from "assets";

export default function OpenSession() {
    const { t } = useTranslation();
    const [sessionCode, setSessionCode] = useState("");
    const [isOpenSessionButtonDisabled, setIsOpenSessionButtonDisabled] = useState(true);
    const IconOpensession = icons['opensession'];

    const handleOpenSession = () => {
        if (!sessionCode.trim()) return;

        const orchardUrl = getOrchardUrlFromEnv(process.env.REACT_APP_ENV_VAR ?? "")
        const url = `${orchardUrl}/go?code=${sessionCode}`;

        window.open(url, "_blank");
    };

    const onSessionCodeChange = (value: string) => {
        setSessionCode(value)
        setIsOpenSessionButtonDisabled(value.length <= 3)
    };

    return (

        <Form.Group className="openSession">
            <Form.Label htmlFor="openSession__input" className="openSession__label">
                <span className="iconWrapper">{<IconOpensession />}</span>
                <span>{t("open_session")}</span>
            </Form.Label>
            <div className="openSession_wrapper">
                <Form.Control
                    id="openSession__input"
                    aria-describedby="code-instructions"
                    type="text" maxLength={5}
                    placeholder="_ _ _ _"
                    value={sessionCode}
                    onChange={(e) => onSessionCodeChange(e.target.value)} />

                <Button
                    variant="outline-secondary"
                    aria-label={t("run_session")}
                    disabled={isOpenSessionButtonDisabled}
                    className="openSession__button"
                    onClick={handleOpenSession}>
                    <RiSendPlaneFill />
                </Button>
            </div>
            <span id="code-instructions" className="screen_reader-only">
                {t("open_session_instruction")}
            </span>
        </Form.Group>
    );
}

